var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22189_11155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7803 2.48128L28.2802 0.981417C27.9877 0.688677 27.513 0.688448 27.2203 0.980959C27.2201 0.981188 27.2198 0.981188 27.2198 0.981417L18.2197 9.98129C18.0792 10.1221 18 10.3127 18 10.5116V12.0117C18 12.4257 18.3358 12.7615 18.75 12.7615H20.2501C20.449 12.7615 20.6397 12.6826 20.7802 12.542L29.7803 3.54192C30.0731 3.24918 30.0733 2.77471 29.7808 2.48174C29.7806 2.48174 29.7803 2.48151 29.7803 2.48128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2501 14.2617H18.75C17.5079 14.2603 16.5013 13.2537 16.4999 12.0118V10.5117C16.4985 9.91476 16.7359 9.34186 17.1591 8.92095L22.3183 3.76172H3.75C1.67977 3.76401 0.00228882 5.44148 0 7.51172V21.0116C0.00228882 23.0819 1.67977 24.7596 3.75 24.7616H10.5V28.5117C10.5 28.9259 10.8357 29.2617 11.25 29.2617C11.4123 29.2617 11.5702 29.2091 11.7 29.1116L17.5008 24.7616H24.7499C26.8202 24.7594 28.4979 23.0817 28.4999 21.0116V6.94341L21.8408 13.6025C21.4197 14.0259 20.847 14.2631 20.2501 14.2617ZM5.2501 8.26177H12.7501C13.1642 8.26177 13.4999 8.59754 13.4999 9.01182C13.4999 9.42586 13.1642 9.76163 12.7501 9.76163H5.2501C4.83582 9.76163 4.50005 9.42609 4.50005 9.01182C4.50005 8.59754 4.83582 8.26177 5.2501 8.26177ZM5.2501 12.7616H12.7501C13.1642 12.7616 13.4999 13.0974 13.4999 13.5116C13.4999 13.9259 13.1642 14.2617 12.7501 14.2617H5.2501C4.83582 14.2617 4.50005 13.9259 4.50005 13.5116C4.50005 13.0976 4.83582 12.7616 5.2501 12.7616ZM23.9999 18.0117C23.9999 18.426 23.6641 18.7617 23.2501 18.7617H5.2501C4.83582 18.7617 4.50005 18.426 4.50005 18.0117C4.50005 17.5976 4.83582 17.2616 5.2501 17.2616H23.2501C23.6641 17.2616 23.9999 17.5974 23.9999 18.0117Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22189_11155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.408a0d835461c618be6454b194546309.svg";
export { ForwardRef as ReactComponent };